// Configuration for the "use the mobile app" nudge shown when staff clock in/out
// from the web. Tune or disable this as mobile adoption increases.
//
// To DISABLE: set `enabled` to false below, or build/run with the env var
// VUE_APP_WEB_CLOCK_NUDGE=false (the env var, when set, wins over the default).
const envFlag = process.env.VUE_APP_WEB_CLOCK_NUDGE;

export const clockNudgeConfig = {
  // Default on. Env var override: VUE_APP_WEB_CLOCK_NUDGE="false" turns it off.
  enabled: envFlag !== undefined ? envFlag !== "false" : true,

  // Mobile app store links.
  iosUrl: "https://apps.apple.com/us/app/oppo-app/id6754663032",
  androidUrl: "https://play.google.com/store/apps/details?id=com.oppo.app",
};

export default clockNudgeConfig;
